import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { ModalTrigger, Text, Glyphicon } from 'reaxl';
import FilterLocationModal from '../FilterLocationModal';

/**
 *  CTA to open/close FilterLocationModal
 *
 */
function FilterLocationModalTrigger(_ref) {
  let {
    show = false,
    onHide = () => {},
    onSubmit = () => {},
    onOptionChange = () => {},
    filter = {},
    filters = {},
    errors = {},
    values = {},
    fallbackTriggerText,
    triggerClassName,
    textClassName,
    className,
    searchRadiusValue,
    zipValue,
    ...rest
  } = _ref;
  const zip = values?.zip || fallbackTriggerText || '';
  const ariaLabel = values?.zip ? `Currently searching near ${zip}. Change ZIP Code.` : 'Set your ZIP Code to find vehicles near you.';
  return /*#__PURE__*/_jsx(ModalTrigger, {
    showModal: show,
    modal: /*#__PURE__*/React.createElement(FilterLocationModal, Object.assign({
      onHide: onHide,
      filter: filter,
      filters: filters,
      errors: errors,
      values: values,
      onSubmit: onSubmit,
      onOptionChange: onOptionChange,
      key: "modalTriggerModal",
      searchRadiusValue: searchRadiusValue,
      zipValue: zipValue
    }, rest)),
    className: triggerClassName,
    "aria-label": ariaLabel
  }, void 0, /*#__PURE__*/_jsx(Text, {
    componentClass: "span",
    className: className,
    weight: "bold",
    size: 300
  }, "modalTriggerText", _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "map-marker"
  })), /*#__PURE__*/_jsx("span", {
    className: clsx('padding-left-1', textClassName)
  }, void 0, zip)));
}
export default FilterLocationModalTrigger;